<div class="wiki-list" cdkDropListGroup>
  <div cdkDropList (cdkDropListDropped)="dropWikiGroup($event)">
    <div class="wiki-list-group-container">
      @for (wikiGroup of wikiGroups; track wikiGroup._id; let wikiGroupIndex = $index) {
        <div class="wiki-group-card" cdkDrag [cdkDragDisabled]="dragDisabled">
          <div class="wiki-group-header">
            <div class="wiki-group-header__drag-handler-container">
              <div
                class="wiki-group-header__drag-handler-wrapper"
                (mouseover)="hoveringIndex = wikiGroupIndex"
                (mouseout)="hoveringIndex = null"
              >
                <mat-icon
                  *ngIf="hoveringIndex === wikiGroupIndex"
                  svgIcon="drag-handler"
                  class="wiki-group-card__drag-handler"
                  cdkDragHandle
                  (touchstart)="dragDisabled = false"
                  (touchend)="dragDisabled = true"
                  (mousedown)="dragDisabled = false"
                  (mouseup)="dragDisabled = true"
                />

                <span
                  *ngIf="hoveringIndex !== wikiGroupIndex"
                  class="wiki-group__random-circle-color"
                  [style.backgroundColor]="randomColors[wikiGroupIndex]"
                ></span>
              </div>
              <span class="wiki-group-name">{{ wikiGroup.name }}</span>
            </div>

            <div class="wiki-group-header__actions-container">
              <button type="button" class="edit-wiki-group-button" (click)="onEditWikiGroup(wikiGroup)">
                <oph-icon name="menu-horizontal"></oph-icon>
              </button>
              <oph-button
                class="wiki-group-header__new-post-button"
                (buttonClick)="onCreateWikiItem(wikiGroup)"
                [style]="{height: '34px', 'border-radius': '8px', 'min-width': '134px'}"
                color="green"
              >
                <mat-icon svgIcon="plus-white" />
                New Post
              </oph-button>
            </div>
          </div>

          <div
            class="wiki-group-items"
            cdkDropList
            [id]="wikiGroup._id"
            [cdkDropListData]="wikiGroup.items"
            [cdkDropListConnectedTo]="getWikiGroupIds()"
            (cdkDropListDropped)="dropWikiItem($event)"
          >
            @for (item of wikiGroup.items; track item._id) {
              <wiki-item [wikiItem]="item" (onClick)="onEditWikiItem(item)" />
            } @empty {
              <div class="wiki-item-empty">
                <span class="wiki-item-empty-text">Create or move a post to this group</span>
                <oph-add-button (buttonClick)="onCreateWikiItem(wikiGroup)">New Post</oph-add-button>
              </div>
            }
          </div>

          <div class="wiki-group-drag-preview" *cdkDragPreview>
            {{ wikiGroup.name }}
          </div>

          <div class="wiki-group-drag-placeholder" *cdkDragPlaceholder></div>
        </div>
      }
    </div>
  </div>
  <div class="add-group-button-container">
    <oph-add-button (buttonClick)="onCreateWikiGroup()">Add Group</oph-add-button>
  </div>
</div>
